/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_FeaturedInputs */

const en_directory_home_featured = /** @type {(inputs: Directory_Home_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured AI Tools`)
};

const zh_directory_home_featured = /** @type {(inputs: Directory_Home_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选 AI 工具`)
};

/**
* | output |
* | --- |
* | "Featured AI Tools" |
*
* @param {Directory_Home_FeaturedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_featured = /** @type {((inputs?: Directory_Home_FeaturedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_FeaturedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_featured(inputs)
	return zh_directory_home_featured(inputs)
});
export { directory_home_featured as "directory.home.featured" }